import React, { useState, useEffect, useMemo } from 'react';

import { dataGridPremiumColumns, generateColumnsFromDynProps } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import batchSnService from '../../service/batchSn.service';

const BatchSnReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'addDate', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    batchSnService.getData(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
    },
    {
      field: 'batchSn',
      headerName: 'Sarzs',
      type: 'string',
    },
    {
      field: 'addDate',
      type: 'date',
      headerName: 'Beérkezés dátuma',
      valueGetter: (_data, row) => {
        return new Date(row.addDate);
      },
    },
    {
      field: 'lot',
      headerName: 'LOT',
      type: 'string',
    },
    {
      field: 'supplierId',
      headerName: 'Beszállító azon.',
      type: 'string',
    },
    {
      field: 'expDate',
      type: 'date',
      headerName: 'Lejárat',
      valueGetter: (_data, row) => {
        return row.expDate ? new Date(row.expDate) : null;
      },
    },
    {
      field: 'mnfDate',
      type: 'date',
      headerName: 'Gyártás',
      valueGetter: (_data, row) => {
        return row.mnfDate ? new Date(row.mnfDate) : null;
      },
    },
    {
      field: 'batchAttribute1',
      headerName: 'Attribútum 1',
      type: 'string',
    },
    {
      field: 'batchAttribute2',
      headerName: 'Attribútum 2',
      type: 'string',
    },
    {
      field: 'price',
      headerName: 'Ár',
      type: 'number',
    },
    {
      field: 'other',
      headerName: 'Egyéb',
      type: 'string',
    },
    {
      field: 'comment',
      headerName: 'Megjegyzés',
      type: 'string',
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.BatchSn}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      getRowId={(row) => row.batchSnId}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default BatchSnReports;
